/*
 * Readable listing URLs: name + id, e.g. "gokarna-beach-trek-6a00f3c2e1b4a5d6c7e8f901".
 * Only the id at the end is used to load the listing, so a renamed listing's
 * old links keep working.
 */
const ID_AT_END = /([a-f0-9]{24})$/i;
const MAX_NAME_LENGTH = 60;

// "Gokarna Beach Trek (2D/1N)!" -> "gokarna-beach-trek-2d-1n"
export function slugify(text = '') {
    const slug = String(text)
        .normalize('NFKD')
        .replace(/[̀-ͯ]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    if (slug.length <= MAX_NAME_LENGTH) return slug;
    // cut at a word break, not mid-word
    return slug.slice(0, MAX_NAME_LENGTH).replace(/-[^-]*$/, '');
}

/** URL part for a listing: "name-id", or just the id when there's no name */
export function listingSlug(title, id) {
    const name = slugify(title);
    return name ? `${name}-${id}` : String(id);
}

/** The listing id inside a URL part ("name-id" or a plain id) */
export function idFromSlug(slug = '') {
    const match = String(slug).match(ID_AT_END);
    return match ? match[1] : slug;
}
